module.exports = __webpack_public_path__ + "static/img/banner.b24aba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productimg/banner.png
// module id = D9u2
// module chunks = 0